<p-divider class="sigale-divider">
	<div class="titre-divider">{{ titre | translate }}</div>
</p-divider>
